var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaveCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 14V9.33333C4.66667 8.59695 5.26362 8 6 8H10C10.7364 8 11.3333 8.59695 11.3333 9.33333V14M6.66667 10.6667H9.33333M3.33333 14H12.6667C13.403 14 14 13.403 14 12.6667V3.33333C14 2.59695 13.403 2 12.6667 2H5.88562C5.532 2 5.19286 2.14048 4.94281 2.39052L2.39052 4.94281C2.14048 5.19286 2 5.532 2 5.88562V12.6667C2 13.403 2.59695 14 3.33333 14Z",
    stroke: "#000536",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveCard);
export default __webpack_public_path__ + "static/media/save-card.4d30efa0dd431a3ceb50798926f3d090.svg";
export { ForwardRef as ReactComponent };